const loginRoutes = {
  index: '/login',
  forgotUsername: '/login/forgotusername',
  forgotUsernameEmailSent: '/login/forgotusername/emailsent',
  forgotPassword: '/login/forgotpassword',
  forgotPasswordEmailSent: '/login/forgotpassword/emailsent',
  resetPassword: '/login/forgotpassword/reset',
  passwordResetSuccess: '/login/forgotpassword/success',
  // Temporary: A little landing page for legacy contact verification emails.
  legacyContactVerification: '/login/contactverification',
};

export const routes = {
  index: '/',
  checkin: '/checkin',
  login: loginRoutes,
};
